export const CARDS_CASE = [
  {
    title: '新築',
    message: '建築士とつくる、暮らしに合わせた新築住宅。',
    img_path: '/images/case/new/③Y邸/1.jpg',
    url: './case/new',
  },
  {
    title: 'リフォーム',
    message: '今の住まいを活かす、間取り・水回りの改修。',
    img_path: '/images/case/reform/⑰フローリング増し張り工事/2.jpg',
    url: './case/reform',
  },
  {
    title: 'オフィス・店舗',
    message: '店舗・事務所・倉庫の新築と改修。',
    img_path: '/images/case/office/①亀屋栄泉様/1.jpg',
    url: './case/office',
  },
];
export var CARDS_NEW = [];
export var CARDS_REFORM = [];
export var CARDS_OFFICE = [];

//新築
CARDS_NEW.push({
  title: 'Y邸',
  message: '',
  img_path: '/images/case/new/①Y邸/1.jpg',
  url: '/case/new/detail?title=①Y邸&page=13',
});
CARDS_NEW.push({
  title: 'S邸',
  message: '',
  img_path: '/images/case/new/②S邸/1.jpg',
  url: '/case/new/detail?title=②S邸&page=13',
});
CARDS_NEW.push({
  title: 'Y邸',
  message: '',
  img_path: '/images/case/new/③Y邸/1.jpg',
  url: '/case/new/detail?title=③Y邸&page=9',
});
CARDS_NEW.push({
  title: 'S邸',
  message: '',
  img_path: '/images/case/new/④S邸/1.jpg',
  url: '/case/new/detail?title=④S邸&page=9',
});
CARDS_NEW.push({
  title: 'K邸',
  message: '',
  img_path: '/images/case/new/⑤K邸/1.jpg',
  url: '/case/new/detail?title=⑤K邸&page=13',
});
CARDS_NEW.push({
  title: 'A邸',
  message: '',
  img_path: '/images/case/new/⑥A邸/1.jpg',
  url: '/case/new/detail?title=⑥A邸&page=15',
});
CARDS_NEW.push({
  title: 'A邸',
  message: '',
  img_path: '/images/case/new/⑦A邸/1.jpg',
  url: '/case/new/detail?title=⑦A邸&page=10',
});
CARDS_NEW.push({
  title: 'K邸',
  message: '',
  img_path: '/images/case/new/⑧K邸/1.jpg',
  url: '/case/new/detail?title=⑧K邸&page=17',
});
CARDS_NEW.push({
  title: 'Y邸',
  message: '',
  img_path: '/images/case/new/⑨Y邸/1.jpg',
  url: '/case/new/detail?title=⑨Y邸&page=10',
});
CARDS_NEW.push({
  title: 'K邸',
  message: '',
  img_path: '/images/case/new/⑩K邸/1.jpg',
  url: '/case/new/detail?title=⑩K邸&page=12',
});
CARDS_NEW.push({
  title: 'K邸',
  message: '',
  img_path: '/images/case/new/⑪K邸/1.jpg',
  url: '/case/new/detail?title=⑪K邸&page=10',
});
CARDS_NEW.push({
  title: 'M邸',
  message: '',
  img_path: '/images/case/new/⑫M邸/1.jpg',
  url: '/case/new/detail?title=⑫M邸&page=13',
});
CARDS_NEW.push({
  title: 'A邸',
  message: '',
  img_path: '/images/case/new/⑬A邸/1.jpg',
  url: '/case/new/detail?title=⑬A邸&page=12',
});
CARDS_NEW.push({
  title: 'K邸(車庫）',
  message: '',
  img_path: '/images/case/new/⑭K邸(車庫）/1.jpg',
  url: '/case/new/detail?title=⑭K邸(車庫）&page=8',
});
CARDS_NEW.push({
  title: 'O邸',
  message: '',
  img_path: '/images/case/new/⑮O邸/1.jpg',
  url: '/case/new/detail?title=⑮O邸&page=10',
});
CARDS_NEW.push({
  title: 'S邸',
  message: '',
  img_path: '/images/case/new/⑯S邸/1.jpg',
  url: '/case/new/detail?title=⑯S邸&page=4',
});
CARDS_NEW.push({
  title: 'T邸',
  message: '',
  img_path: '/images/case/new/⑰T邸/1.jpg',
  url: '/case/new/detail?title=⑰T邸&page=9',
});
CARDS_NEW.push({
  title: 'Y邸',
  message: '',
  img_path: '/images/case/new/⑱Y邸/1.jpg',
  url: '/case/new/detail?title=⑱Y邸&page=8',
});
CARDS_NEW.push({
  title: 'U邸',
  message: '',
  img_path: '/images/case/new/⑲U邸/1.jpg',
  url: '/case/new/detail?title=⑲U邸&page=8',
});
CARDS_NEW.push({
  title: 'I邸',
  message: '',
  img_path: '/images/case/new/⑳I邸/1.jpg',
  url: '/case/new/detail?title=⑳I邸&page=8',
});
CARDS_NEW.push({
  title: 'N邸',
  message: '',
  img_path: '/images/case/new/㉑N邸/1.jpg',
  url: '/case/new/detail?title=㉑N邸&page=8',
});
CARDS_NEW.push({
  title: 'I邸',
  message: '',
  img_path: '/images/case/new/㉒I邸/1.jpg',
  url: '/case/new/detail?title=㉒I邸&page=11',
});
CARDS_NEW.push({
  title: 'M邸',
  message: '',
  img_path: '/images/case/new/㉓M邸/1.jpg',
  url: '/case/new/detail?title=㉓M邸&page=8',
});
CARDS_NEW.push({
  title: 'N邸',
  message: '',
  img_path: '/images/case/new/㉔N邸/1.jpg',
  url: '/case/new/detail?title=㉔N邸&page=8',
});
CARDS_NEW.push({
  title: 'S邸',
  message: '',
  img_path: '/images/case/new/㉕S邸/1.jpg',
  url: '/case/new/detail?title=㉕S邸&page=7',
});
CARDS_NEW.push({
  title: 'S邸',
  message: '',
  img_path: '/images/case/new/㉖S邸/1.jpg',
  url: '/case/new/detail?title=㉖S邸&page=5',
});
CARDS_NEW.push({
  title: 'S邸',
  message: '',
  img_path: '/images/case/new/㉗S邸/1.jpg',
  url: '/case/new/detail?title=㉗S邸&page=5',
});
CARDS_NEW.push({
  title: 'I邸',
  message: '',
  img_path: '/images/case/new/㉘I邸/1.jpg',
  url: '/case/new/detail?title=㉘I邸&page=3',
});
CARDS_NEW.push({
  title: 'アパート①',
  message: '',
  img_path: '/images/case/new/㉙アパート①/1.jpg',
  url: '/case/new/detail?title=㉙アパート①&page=2',
});
CARDS_NEW.push({
  title: 'アパート②',
  message: '',
  img_path: '/images/case/new/㉚アパート②/1.jpg',
  url: '/case/new/detail?title=㉚アパート②&page=3',
});
CARDS_NEW.push({
  title: 'アパート③',
  message: '',
  img_path: '/images/case/new/㉛アパート③/1.jpg',
  url: '/case/new/detail?title=㉛アパート③&page=3',
});

CARDS_NEW.push({
  title: 'M邸',
  message: '',
  img_path: '/images/case/new/㉜M邸/1.jpg',
  url: '/case/new/detail?title=㉜M邸&page=21',
});
CARDS_NEW.push({
  title: 'アパートM.BASE',
  message: '',
  img_path: '/images/case/new/㉝アパートM.BASE/1.jpg',
  url: '/case/new/detail?title=㉝アパートM.BASE&page=21',
});

//リフォーム
CARDS_REFORM.push({
  title: '和室解体工事',
  message: '',
  img_path: '/images/case/reform/①和室解体工事/1.jpg',
  url: '/case/reform/detail?title=①和室解体工事&page=5',
});
CARDS_REFORM.push({
  title: '屋根替え工事',
  message: '',
  img_path: '/images/case/reform/②屋根替え工事/1.jpg',
  url: '/case/reform/detail?title=②屋根替え工事&page=7',
});
CARDS_REFORM.push({
  title: 'ｷｯﾁﾝ交換工事',
  message: '',
  img_path: '/images/case/reform/③ｷｯﾁﾝ交換工事/1.jpg',
  url: '/case/reform/detail?title=③ｷｯﾁﾝ交換工事&page=2',
});
CARDS_REFORM.push({
  title: 'ﾕﾆｯﾄﾊﾞｽ交換工事',
  message: '',
  img_path: '/images/case/reform/④ﾕﾆｯﾄﾊﾞｽ交換工事/1.jpg',
  url: '/case/reform/detail?title=④ﾕﾆｯﾄﾊﾞｽ交換工事&page=2',
});
CARDS_REFORM.push({
  title: '洗面台交換工事',
  message: '',
  img_path: '/images/case/reform/⑤洗面台交換工事/1.jpg',
  url: '/case/reform/detail?title=⑤洗面台交換工事&page=2',
});
CARDS_REFORM.push({
  title: '内窓設置',
  message: '',
  img_path: '/images/case/reform/⑥内窓設置/1.jpg',
  url: '/case/reform/detail?title=⑥内窓設置&page=6',
});
CARDS_REFORM.push({
  title: 'ｶｯﾌﾟﾎﾞｰﾄﾞ設置工事',
  message: '',
  img_path: '/images/case/reform/⑦ｶｯﾌﾟﾎﾞｰﾄﾞ設置工事/1.jpg',
  url: '/case/reform/detail?title=⑦ｶｯﾌﾟﾎﾞｰﾄﾞ設置工事&page=3',
});
CARDS_REFORM.push({
  title: '屋根、外壁塗装　ｺｰｷﾝｸﾞ打ち替え工事',
  message: '',
  img_path: '/images/case/reform/⑧屋根、外壁塗装　ｺｰｷﾝｸﾞ打ち替え工事/1.jpg',
  url: '/case/reform/detail?title=⑧屋根、外壁塗装　ｺｰｷﾝｸﾞ打ち替え工事&page=8',
});
CARDS_REFORM.push({
  title: '玄関ドアリフォーム（カバー工法）',
  message: '',
  img_path: '/images/case/reform/⑨玄関ドアリフォーム（カバー工法）/1.jpg',
  url: '/case/reform/detail?title=⑨玄関ドアリフォーム（カバー工法）&page=3',
});
CARDS_REFORM.push({
  title: 'サッシ交換工事',
  message: '',
  img_path: '/images/case/reform/⑩サッシ交換工事/1.jpg',
  url: '/case/reform/detail?title=⑩サッシ交換工事&page=4',
});
CARDS_REFORM.push({
  title: '洗面所・浴室リフォーム',
  message: '',
  img_path: '/images/case/reform/⑪洗面所・浴室リフォーム/1.jpg',
  url: '/case/reform/detail?title=⑪洗面所・浴室リフォーム&page=5',
});
CARDS_REFORM.push({
  title: '外壁塗装工事1',
  message: '',
  img_path: '/images/case/reform/⑫外壁塗装工事1/1.jpg',
  url: '/case/reform/detail?title=⑫外壁塗装工事1&page=4',
});
CARDS_REFORM.push({
  title: 'バルコニー防水工事',
  message: '',
  img_path: '/images/case/reform/⑬バルコニー防水工事/1.jpg',
  url: '/case/reform/detail?title=⑬バルコニー防水工事&page=2',
});
CARDS_REFORM.push({
  title: 'ｷｯﾁﾝ交換、床貼り工事',
  message: '',
  img_path: '/images/case/reform/⑭ｷｯﾁﾝ交換、床貼り工事/1.jpg',
  url: '/case/reform/detail?title=⑭ｷｯﾁﾝ交換、床貼り工事&page=4',
});
CARDS_REFORM.push({
  title: '外壁塗装工事2',
  message: '',
  img_path: '/images/case/reform/⑮外壁塗装工事2/1.jpg',
  url: '/case/reform/detail?title=⑮外壁塗装工事2&page=4',
});
CARDS_REFORM.push({
  title: '建具増設工事',
  message: '',
  img_path: '/images/case/reform/⑯建具増設工事/1.jpg',
  url: '/case/reform/detail?title=⑯建具増設工事&page=2',
});
CARDS_REFORM.push({
  title: 'フローリング増し張り工事',
  message: '',
  img_path: '/images/case/reform/⑰フローリング増し張り工事/1.jpg',
  url: '/case/reform/detail?title=⑰フローリング増し張り工事&page=3',
});

CARDS_REFORM.push({
  title: 'Y邸',
  message: '',
  img_path: '/images/case/reform/⑱Y邸/1.jpg',
  url: '/case/reform/detail?title=⑱Y邸&page=15',
});

//オフィス
CARDS_OFFICE.push({
  title: '亀屋栄泉様',
  message: '',
  img_path: '/images/case/office/①亀屋栄泉様/1.jpg',
  url: '/case/office/detail?title=①亀屋栄泉様&page=7',
});
CARDS_OFFICE.push({
  title: 'とぶの坂様',
  message: '',
  img_path: '/images/case/office/②とぶの坂様/1.jpg',
  url: '/case/office/detail?title=②とぶの坂様&page=7',
});
CARDS_OFFICE.push({
  title: '飯田建築有限会社',
  message: '',
  img_path: '/images/case/office/③飯田建築有限会社/1.jpg',
  url: '/case/office/detail?title=③飯田建築有限会社&page=12',
});
CARDS_OFFICE.push({
  title: 'しらい様',
  message: '',
  img_path: '/images/case/office/④しらい様/1.jpg',
  url: '/case/office/detail?title=④しらい様&page=4',
});
CARDS_OFFICE.push({
  title: '内田製本加工様',
  message: '',
  img_path: '/images/case/office/⑤内田製本加工様/1.jpg',
  url: '/case/office/detail?title=⑤内田製本加工様&page=13',
});

CARDS_OFFICE.push({
  title: 'ビル防水改修工事',
  message: '',
  img_path: '/images/case/office/⑥ビル防水改修工事/1.jpg',
  url: '/case/office/detail?title=⑥ビル防水改修工事&page=5',
});

// 事例一覧は新しいものを先頭に表示する。
// 上の push は古い順（登録順）で並んでいるため、ここで一度だけ反転させる。
// ※ CARDS_CASE はカテゴリの並び（新築 / リフォーム / オフィス）なので対象外。
CARDS_NEW.reverse();
CARDS_REFORM.reverse();
CARDS_OFFICE.reverse();

/** 会社情報（フッター・ナビの電話番号などで参照） */
export const COMPANY = {
  name: '飯田建築 有限会社',
  zip: '〒358-0054',
  address: '埼玉県入間市野田1481-2',
  tel: '04-2932-1316',
  fax: '04-2932-4189',
};

/** グローバルナビ・フッターのサイトマップで共用するリンク */
export const NAV_ITEMS = [
  { label: '会社情報', href: '/information' },
  { label: '施工事例', href: '/case' },
  { label: '家づくりの流れ', href: '/flow' },
  { label: 'スタッフ紹介', href: '/staff' },
];

/** 対応エリア（詳細は /information の営業エリアを参照） */
export const AREA_ITEMS = [
  { label: '埼玉県（入間市・所沢市ほか）', href: '/information' },
  { label: '東京都（青梅市・羽村市ほか）', href: '/information' },
];

export const URL_IN = 'https://www.instagram.com/iida_kenchiku/';
export const URL_TH = 'https://www.threads.net/@iida_kenchiku';
export const URL_TW = 'https://twitter.com/iida_kenchiku';
export const URL_PI = 'https://www.pinterest.jp/kiidac70/';
